import React from 'react';

interface HeroProps {
    onOpenModal: () => void;
    spotsTaken: number;
    totalSpots: number;
    loading: boolean;
}

export const Hero: React.FC<HeroProps> = ({ onOpenModal, spotsTaken, totalSpots, loading }) => {

    return (
        <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
            {/* Background Effects */}
            <div className="absolute inset-0">
                <div className="absolute top-20 left-20 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
                <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3Cpattern%20id%3D%22grid%22%20width%3D%2260%22%20height%3D%2260%22%20patternUnits%3D%22userSpaceOnUse%22%3E%3Cpath%20d%3D%22M%2060%200%20L%200%200%200%2060%22%20fill%3D%22none%22%20stroke%3D%22white%22%20stroke-width%3D%220.5%22%20opacity%3D%220.05%22%2F%3E%3C%2Fpattern%3E%3C%2Fdefs%3E%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22url(%23grid)%22%2F%3E%3C%2Fsvg%3E')] opacity-50"></div>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="inline-flex items-center space-x-2 px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full mb-8">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-500"></span>
                    </span>
                    <span className="text-sm text-purple-300">
                        {loading ? (
                            'Limited to 1,000 Lifetime Spots'
                        ) : (
                            `${totalSpots - spotsTaken} of 1,000 Spots Remaining`
                        )}
                    </span>
                </div>

                <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
                    Meet NyxBot <br />
                    <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent animate-gradient">
                        the nightwatcher for Solana yield
                    </span>
                </h1>

                <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
                    Flash stake into high-APR DLMM pools on Meteora, using your own custom filters -
                    or let our AI suggest optimal strategies based on your risk appetite. 
                    All on Telegram. All while you rest.
                </p>

                <div className="flex items-center justify-center space-x-2 mb-12">
                    <span className="text-2xl">✨</span>
                    <span className="text-2xl font-semibold text-transparent bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text">
                        "You sleep. We flash stake."
                    </span>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
                    <button 
                        onClick={onOpenModal}
                        className="group relative px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg text-white font-bold text-lg hover:from-purple-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg hover:shadow-purple-500/25"
                    >
                        <span className="flex flex-col">
                            <span>Join Early Access</span>
                            <span className="text-sm font-normal opacity-90">0.1 SOL</span>
                        </span>
                    </button>
                    <div className="flex items-center space-x-2 text-gray-400">
                        <span>⚡</span>
                        <span>500+ commits needed to build</span>
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto">
                    <div className="text-center">
                        <div className="text-3xl font-bold text-white mb-1">24/7</div>
                        <div className="text-sm text-gray-400">Monitoring</div>
                    </div>
                    <div className="text-center">
                        <div className="text-3xl font-bold text-white mb-1">1,000</div>
                        <div className="text-sm text-gray-400">Lifetime Spots</div>
                    </div>
                    <div className="text-center">
                        <div className="text-3xl font-bold text-white mb-1">200%+</div>
                        <div className="text-sm text-gray-400">Target APR</div>
                    </div>
                </div>
            </div>
        </section>
    );
};